<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/afOs38/tc-custom/9780062407290.jpg?1731055858905" alt="This image is the cover for the book Shattered Empire, Sorcery Ascendant Sequence"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shattered Empire, Sorcery Ascendant Sequence
      </h1>
      <p class="bookDescription body article font2">
        <b>A young sorcerer must learn to wield his extraordinary powers to defeat two warring empires in the stunning conclusion to the Sorcery Ascendant Sequence.</b><br/><br/><i>In a battle of armies and sorcerers, empires will fall.</i><br/><br/>After young Caldan’s parents were slain, a group of monks raised the boy and initiated him into the arcane mysteries of sorcery. But when the Mahruse Empire was attacked, and the lives of his friends hung in the balance, he was forced to make a dangerous choice.<br/><br/>Now, as two mighty empires face off in a deadly game of supremacy, potent sorcery and creatures from legend have been unleashed. To turn the tide of war and prevent annihilation, Caldan must learn to harness his fearsome and forbidden magic. But as he grows into his powers, the young sorcerer realizes that not all the monsters are on the other side.<br/><br/>And though traps and pitfalls lie ahead, and countless lives are at stake, one thing is certain: to save his life, his friends, and his world, Caldan must risk all to defeat a sorcerer of immense power.<br/><br/>Failure will doom the world.<br/><br/>Success will doom Caldan.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mitchell Hogan
      </h2>
      
      <p class="authorDescription body article"><P>When he was eleven, Mitchell Hogan was given <I>The Hobbit</I> and <I>The Lord of the Rings</I> trilogy to read, and a love of fantasy novels was born. He spent the next ten years reading, rolling dice, and playing computer games, with some school and university thrown in. Along the way he accumulated numerous bookcases&#8217; worth of fantasy and sci-fi novels, and he doesn&#8217;t look to stop anytime soon. For a decade he put off his dream of writing, then he quit his job and wrote <I>A Crucible of Souls</I>, Book One in the Sorcery Ascendant Sequence. He now writes full-time and is eternally grateful to the readers who took a chance on an unknown self-published author. He lives in Sydney, Australia, with his wife, Angela, and daughter, Isabelle.&#160;</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?05e52cc9